/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



app.controller('ArchivCtrl', ['$rootScope','$scope', '$http', "$rootScope", 'MainService', 'NetworkService', 'IntentService', function ($rootScope, $scope, $http, MainService, NetworkService, IntentService) {


    NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })
        $scope.error = function (msg) {
            Notification.error(msg);
        };

        $scope.success = function (msg) {
            Notification.success(msg);
        };

        $scope.openShiftCalendar = function ()
        {
            window.location.replace("http://atlas.hosiwien.at/Schichtmanager.php?eventid=" + $scope.eventId);
        }


        $scope.repaint = function ()
        {
            NetworkService.getEvents(function (data) {
                $scope.events = data
            })
        }

        $scope.repaint()

        $scope.getEventImage = function (event_id)
        {
            var str = "imgs/eventImgs/event_" + event_id + ".png"
            return str;
        }

        $scope.unArchiveEvent = function (event_id)
        {
            NetworkService.unArchiveEvent(event_id, function (data) {
                $scope.repaint()
            })
        }

        $scope.printDate = function (date) {
            dateObj = new mDate(date);

            return dateObj.getDate();
        }

    }]);

